export const toBanglaYear = (year) => {
  year = year.toString();

  let banglaYear = "";
  for (let i = 0; i < year.length; i++) {
    banglaYear += String.fromCharCode(year.charCodeAt(i) + 2486);
  }

  return banglaYear;
}